import { useContext, useEffect } from "react";
import { FinalTableConfig } from "@beeldit/core/models/FinalTableConfig.interface";
import { ListActionContext } from "../actions/list/ListActionContext";
import BeelditTable from "@beeldit/core/components/BeelditTable";
import BalanceAccordionTable from "./BalanceAccordionTable";

interface Props {
  tableConfig: FinalTableConfig;
  tableData: any;
  onOrderByChange: any;
}

function BalanceTable(props: Props) {
  const { tableData, tableConfig, onOrderByChange } = props;
  const { orderBy } = useContext(ListActionContext);

  useEffect(() => {
    tableConfig.index();
  }, []);

  return tableData ? (
    <BalanceAccordionTable
      data={tableData}
      orderBy={orderBy}
      onOrderByChange={onOrderByChange}
      refresh={tableConfig.index}
    ></BalanceAccordionTable>
  ) : (
    <div>Loading...</div>
  );
}

export default BalanceTable;
